import classNames from 'classnames';
import { memo, useMemo } from 'react';
import { Img } from 'react-image';

import './index.css';

type AssetProps = {
  symbol: string;
  className?: string;
  ['data-test']?: string;
};

const AssetToken = (props: AssetProps) => {
  const className = classNames('asset-icon-svg icon-svg', {
    [`${props.className}`]: props.className,
  });

  const src = useMemo(
    () => [
      `https://assets.xbo.com/token-icons/svg/${props.symbol}.svg`,
      `https://assets.xbo.com/token-icons/png/${props.symbol}.png`,
    ],
    [props.symbol],
  );

  return (
    <Img
      data-test={props['data-test'] ?? ''}
      data-symbol={props.symbol}
      loading='lazy'
      src={src}
      className={className}
      alt=''
    />
  );
};

export default memo(AssetToken);
